var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Input } from "./input";
export var LabeledInputRow = React.forwardRef(function (_a, ref) {
    var label = _a.label, labelClassName = _a.labelClassName, containerClassName = _a.containerClassName, inputProps = __rest(_a, ["label", "labelClassName", "containerClassName"]);
    return (_jsxs("div", { className: "flex " + (containerClassName || ""), children: [_jsx("div", { className: "flex items-center justify-center px-2 py-2 bg-secondary text-secondary-foreground border border-r-0 border-gray-300 dark:border-border rounded-l-lg text-sm font-medium whitespace-nowrap ".concat(labelClassName), children: label }), _jsx("div", { className: "flex-1", children: _jsx(Input, __assign({ ref: ref }, inputProps, { className: "!rounded-l-none border-l-0 ".concat(inputProps.className || '') })) })] }));
});
LabeledInputRow.displayName = "LabeledInputRow";
